/**
 * OVERRIDE ContextNavigation.jsx
 */

import ContextNavigation from '../../../../components/Navigation/ContextNavigation';

export default ContextNavigation;